import {Box, Link, makeStyles, Typography, useMediaQuery} from '@material-ui/core'
import React, {useEffect, useState} from 'react'
import { API_URL } from '../config/env'
import {Link as RouterLink} from 'react-router-dom'
import Chip from '../components/Chip'
import {useSelector} from "react-redux";
import { useTranslation } from 'react-i18next';
import team2 from "../assets/team/6.png";

const useStyles = makeStyles(theme => {
  return {
    successLabel: {
      ...theme.typography.h5,
      fontWeight: theme.typography.fontWeightBold,
      padding: '1.5rem',
    },
  }
})

const SuccessPayment = () => {
  const classes = useStyles()
  const [churchId, setChurchId] = useState(null)
  const { t } = useTranslation()
  const initLanguage = useSelector(state => state.user.isLanguageLoaded)
  const smUp = useMediaQuery(theme => theme.breakpoints.up("sm"))

  useEffect(() => {
    const orderId = localStorage.getItem('order_id')
    if (!orderId) return

    fetch(`${API_URL}service/order/${orderId}`)
      .then(res => res.json())
      .then(order => {
        setChurchId(order.church_uuid)
      })
  }, [])

  return (
      <>
        {initLanguage && (
            <Box p={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                 <Chip className={classes.successLabel}>{t('payment.successTitle')}</Chip>
                 <Typography align={'center'} variant={'h6'}>
                     {t('payment.successMessage')}
                 </Typography>
                 <Link component={RouterLink} to={churchId ? `/item/${churchId}` : '/'} underline={'always'}>
                     <Typography style={{color: '#f87f30'}}>
                         {t('payment.successReturn')}
                     </Typography>
                 </Link>
                <img src={team2} alt={'team2'} style={smUp ? {maxWidth: '30%', marginTop: '100px', aspectRatio: 1} : {maxWidth: '80%', marginTop: '40px', height: '170px', aspectRatio: 0}} />
            </Box>
        )}
      </>
  )
}

export default SuccessPayment
